const FONTS = {
    LEAGUE_SPARTAN: 'league_spartan',
    LEAGUE_SPARTAN_MEDIUM: 'league_spartan_medium',
    LEAGUE_SPARTAN_BOLD: 'league_spartan_bold',
    LXGW_CYRILLIC_BOLD: 'lxgwwenkaitc_bold',
};

export default class Settings {
    static get FONTS() {
        return FONTS;
    }
}
